var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import * as S from './style';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import * as C from "../../loggedout/shared-styles/Colors";
import BlobWithCircle from '../blob-with-circle';
import { assignAbTestsToUser, convertToUUIDFormat, getItemFromLocalStorage, sendEventUsingAvo } from '../../../utils/web-helper';
import { FetchNewABTests, SetGradeApi } from '../../../services/parent-api';
import { AGE_FIVE, K_GRADE, PRE_K_GRADE } from '../../../constant-data/constants';
import { UserOnboardingDetails } from '../../../services/parent-api';
import { useDispatch } from 'react-redux';
import { setNewABTests } from '../../../utils/ab-tests';
import { setSelectedGrade } from '../../../stores/splashverse-onboarding/actions';
export var AgeSelectionV2 = function (props) {
    var _a = useState([false, false, false, false]), blobActiveStates = _a[0], setBlobActiveStates = _a[1];
    var childName = getItemFromLocalStorage('tutoringChildName');
    var BlobsPositioningAndDataMapping = [
        {
            rotate: 0,
            id: '2',
            displayAge: 2,
            circleData: {
                left: 4,
                top: -8,
                color: "".concat(C.darkOrange),
                diameter: 2.2
            }
        },
        {
            rotate: 3,
            id: '3',
            displayAge: 3,
            circleData: {
                left: 50,
                top: 105,
                color: "".concat(C.lightPurple),
                diameter: 2
            }
        },
        {
            rotate: 2,
            id: '4',
            displayAge: 4,
            circleData: {
                left: 56,
                top: -20,
                color: "".concat(C.lightBlue),
                diameter: 2.2
            }
        },
        {
            rotate: 1,
            id: '5',
            displayAge: 5,
            circleData: {
                left: 102,
                top: 102,
                color: "".concat(C.lightPurple),
                diameter: 2.5
            }
        }
    ];
    var _b = useExtendedLocalStorage('splashverse-onboarding', ''), getItem = _b.getItem, setValue = _b.setValue, deleteAll = _b.deleteAll;
    var selectedAge = getItem('selectedAge');
    var selectedGrade = selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE;
    var dispatch = useDispatch();
    useEffect(function () {
        sendEventUsingAvo({ methodName: 'viewedAgeSelectionScreen', params: {} });
    }, []);
    var blobClickHandler = function (id, index) {
        var circle = document.getElementById("circle-".concat(id));
        var blob = document.getElementById("blob-".concat(id));
        circle === null || circle === void 0 ? void 0 : circle.classList.add('circle-active');
        blob === null || blob === void 0 ? void 0 : blob.classList.add('blob-active');
        var updatedStates = [false, false, false, false];
        updatedStates[index] = !updatedStates[index];
        setBlobActiveStates(updatedStates);
        setTimeout(function () {
            return __awaiter(this, void 0, void 0, function () {
                var opt;
                return __generator(this, function (_a) {
                    circle === null || circle === void 0 ? void 0 : circle.classList.remove('circle-active');
                    blob === null || blob === void 0 ? void 0 : blob.classList.remove('blob-active');
                    sendEventUsingAvo({ methodName: 'interactedAgeSelectionScreen', params: { 'clickedOn': "Age ".concat(id) } });
                    opt = { deleteAll: deleteAll };
                    setValue('selectedAge', id);
                    props.goToNextHandler('age_selection_v2', opt);
                    return [2 /*return*/];
                });
            });
        }, 1000);
    };
    var setAgeAndGradeAsUserProperty = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, newAbTests, childId;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, SetGradeApi({
                        grade_code: selectedGrade,
                        student_id: props.students && props.students.length && props.students[0].id ? props.students[0].id : null,
                        onboarding: true,
                        screen_name: childName,
                        age: selectedAge
                    })];
                case 1:
                    resp = _c.sent();
                    return [4 /*yield*/, assignAbTestsToUser((_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.id, selectedGrade)];
                case 2:
                    _c.sent();
                    return [4 /*yield*/, FetchNewABTests({ userId: convertToUUIDFormat((_b = props.currentUser) === null || _b === void 0 ? void 0 : _b.id) })];
                case 3:
                    newAbTests = _c.sent();
                    setNewABTests(newAbTests === null || newAbTests === void 0 ? void 0 : newAbTests.assigned_ab_tests);
                    childId = resp && resp.student && resp.student.id || props.students && props.students.length && props.students[0].id;
                    // //set child id in local storage
                    childId && setValue('childId', childId);
                    setValue('selectedGrade', selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE);
                    dispatch(setSelectedGrade(selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE));
                    UserOnboardingDetails({
                        id: childId,
                        grade_code: selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE,
                        age: selectedAge,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(S.Heading, { children: ["How old is ", childName, "?"] }), _jsxs(S.SubHeading, { children: ["This information will help us tailor the program to ", childName, "'s needs"] }), _jsx(S.BlobsWrapper, { children: BlobsPositioningAndDataMapping.map(function (data, index) { return (_jsx(BlobWithCircle, { blobData: data, isBlobActive: blobActiveStates[index], setBlobActive: function (value) {
                        setBlobActiveStates(function (prevStates) { return prevStates.map(function (prevState, i) { return i === index ? value : prevState; }); });
                    }, index: index, blobClickHandler: blobClickHandler, pdsScreen: false })); }) })] }));
};
export default AgeSelectionV2;
